import { SEMA_DOCUMENT_TYPES } from '../../../../../constants/sema-constants'
import { supportProgramStatus } from '../../../../../constants/support-programs'
import DocumentView from './DocumentView'
import useFetchDocuments from '../../../hooks/useFetchDocuments'
import SectionHeader from '../SectionHeader'
import postMessageToRN, {
  GO_TO_APP,
} from '../../../../../utils/helpers/ReactNativeEvents'
import {
  getEncodedDataFromUrl,
  isInApp,
} from '../../../../../utils/helpers/common'
import { useParams } from 'react-router-dom'
import { useState } from 'react'
import ProceedButton from '../../../../../components/Signup/ProceedButton'
// NAVIGATE_TO_SCREEN,

const UploadDocuments = ({ pageObj, onMoveNext }) => {
  const params = getEncodedDataFromUrl()
  const { documents, fetchDocuments } = useFetchDocuments()
  const [showBtn, setShowBtn] = useState(false)
  const { variant } = useParams()

  const onProceed = () => {
    if (onMoveNext) {
      onMoveNext()
    } else if (isInApp()) {
      goToBack()
    }
  }

  const goToBack = () => {
    postMessageToRN(GO_TO_APP)
    // postMessageToRN(NAVIGATE_TO_SCREEN, {
    //   stack: 'ProgramStackScreen',
    //   navigation: 'ProgramsScreenV2',
    // })
  }

  const onUploadFailed = () => {
    // TODO: Need to handle failed case
    console.log('onUploadFailed')
  }

  const onUploadSuccess = () => {
    console.log('fetching Docs, onSuccess')
    fetchDocuments()
    setShowBtn(true)
  }
  const setUploadedDocuments = (documents) => {
    // TODO: need to handle local preview
    console.log('setUploadedDocuments', documents)
  }

  const pageObjWithFallback = {
    ...pageObj,
    title: 'Upload documents',
    subTitle: `Upload your purchase invoice of your <span class="capitalize">${variant}</span> medication`,
  }

  return (
    <>
      <div className="bg-[#FFF] relative pt-9 px-4 h-full">
        {/* Section Header */}
        <SectionHeader pageObj={pageObjWithFallback} />

        {/* Form */}
        <div className="flex flex-col gap-4 mt-6 pb-6">
          {SEMA_DOCUMENT_TYPES.map((documentTypes) => {
            const document =
              documents?.data?.data?.find(
                (i) => i.title === documentTypes.document_title,
              ) ?? null
            // TODO: Need to revisit this condition
            const documentStatus =
              document?.record_meta_info?.report_status ===
              supportProgramStatus.DOCUMENT_REVIEW_STATUS.REJECTED
                ? 'rejected'
                : document?.record_meta_info?.report_status ===
                    supportProgramStatus.DOCUMENT_REVIEW_STATUS.UNDER_REVIEW
                  ? 'under_review'
                  : 'pending'

            return (
              <DocumentView
                key={documentTypes.document_title}
                document={document}
                documentType={documentTypes.document_type}
                documentStatus={documentStatus}
                onUploadSuccess={onUploadSuccess}
                documentConstObj={documentTypes}
                setUploadedDocuments={setUploadedDocuments}
                onUploadFailed={onUploadFailed}
              />
            )
          })}
        </div>

        {documents?.data?.data?.length > 0 && !params?.hideAction ? (
          <ProceedButton
            onMoveNext={onProceed}
            // disabled={!showBtn}
            onSkip={goToBack}
          />
        ) : null}
      </div>
    </>
  )
}

export default UploadDocuments
